/**
 * Dynamic-import thunks for the workflow editor chunks, hoisted out of the
 * components that use them so several entry points (the overview tab's "Edit
 * Workflow" button, the detail header's "Edit") can warm the same chunk on
 * hover.
 *
 * They must stay at module scope: an `import()` written inside a component body
 * makes the React Compiler bail out of that component entirely
 * (BuildHIR::lowerExpression), which costs more than the prefetch buys.
 */
export const loadWorkflowEditor = () => import('./WorkflowEditor');

export const loadWorkflowEditorPanel = () =>
  import('./components/WorkflowEditorPanel');
